import { Component, OnInit, ViewContainerRef, ViewChild, ComponentRef } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { WVMain } from '../wallboard-view.model';

@Component({
    selector: 'cv-wallboard-view-main',
    templateUrl: './wallboard-view-main.component.html',
    styleUrls: ['./wallboard-view-main.component.scss']
})
export class WallboardViewMainComponent implements OnInit {
    @ViewChild('main', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
    @ViewChild('preRender', { read: ViewContainerRef }) nextSlideRef: ViewContainerRef;

    public wvf: WVMain;
    private reloadPageTime;
    private retryCounter = 0; // Counter to attempt to load next slide
    private componentRef: ComponentRef<any> = null;
    private nextComponentRef: ComponentRef<any> = null;

    constructor(
        private service: WallboardViewService,
    ) { }

    ngOnInit(): void {
        this.wvf = this.service.WVMain;
        this.service.LoadWallboardInfoForView();
        this.loadSlide();
    }

    // slideIndex of -1 loads all slides, a value >=0 will load only the slide at that order position

    shouldForceReload() {
        if (this.reloadPageTime === null)
            return false;
        else
            return Date.now() > this.reloadPageTime;
    }

    loadSlide() {
        if (this.wvf.Slides.length > 0 && this.wvf.FirstSlideReady) {
            setTimeout(() => {
                // Halfway through the slide interval (or 5 secs on a min slide interval) start pre-load of next slide.
                if (this.shouldForceReload())
                    return; // TransitionSlides() will do the actual reload.  But don't pre-load the next slide.
                this.wvf.NextSlideReady = false;
                this.RenderNextSlide()
            }, this.wvf.Slides[this.wvf.CurrentSlide].SlideInterval > 15 ? Math.floor((this.wvf.Slides[this.wvf.CurrentSlide].SlideInterval * 1000) / 2) : 5000);

            setTimeout(() => {
                this.transitionSlides();
            }, this.wvf.Slides[this.wvf.CurrentSlide].SlideInterval * 1000);
        }
        else if (this.wvf.Slides.length > 0 && this.wvf.FirstSlideReady == false) {
            if (!this.componentRef)
                this.RenderFirstSlide();

            setTimeout(() => {
                this.loadSlide();
            }, 1000);
        }
        else {
            setTimeout(() => {
                this.loadSlide();
            }, 1000);
        }
    }

    transitionSlides() {
        if (this.shouldForceReload()) {
            // Amazon Fire TV Sticks have a memory leak and will stop running through the slide show.  Forcing a reload is a workaround.
            window.location.reload();
            return;
        }

        if (this.wvf.NextSlideReady) {
            // If next slide is ready, rotate slides in factory, remove old slide from DOM, tell new slide to run.

            // Can we run the animations here to avoid the double desynced animations?
            this.RunAnimations();

            this.service.rotateSlides();
            setTimeout(() => {
                setTimeout(() => {
                    this.wvf.RunSlide = true;
                    this.SwitchContainers();
                    this.retryCounter = 0; // It worked! Reset the retryCounter
                    this.loadSlide();
                }, 1000); // Trying a wait of 1000 from 0 to allow animations time to run
            });
        }
        else if (this.wvf.SkipNextSlide) {
            // If next slide failed to load, remove slide from DOM, skip it in factory, and load the next slide.
            this.service.skipSlide();
            this.wvf.SkipNextSlide = false;
            this.retryCounter = 0;
            setTimeout(() => {
                setTimeout(() => {
                    this.wvf.NextSlideReady = false;
                    this.RenderNextSlide();
                }, 0);
            });
            setTimeout(() => {
                this.transitionSlides();
                this.retryCounter++;
            }, 1000);
        }
        else if (this.retryCounter >= 60) {
            this.wvf.SkipNextSlide = true;
            this.transitionSlides();
        }
        else {
            setTimeout(() => {
                this.transitionSlides();
                this.retryCounter++;
            }, 1000);
        }
    };

    RenderFirstSlide() {
        this.componentRef = this.viewContainerRef.createComponent(this.service.loadSlide());
        this.componentRef.instance.firstSlide = true;
    }

    RenderNextSlide() {
        this.nextSlideRef.clear();
        this.nextComponentRef = this.nextSlideRef.createComponent(this.service.loadSlide(true));
        this.nextComponentRef.instance.firstSlide = false;
        this.service.loadNextSlideData();
    }

    SwitchContainers() {
        this.viewContainerRef.remove(0);
        this.componentRef = this.nextComponentRef;
        this.viewContainerRef.insert(this.nextComponentRef.hostView);
        this.nextComponentRef = null;
    }

    RunAnimations() {
        let moduleKey = this.wvf.Slides[this.wvf.CurrentSlide].WallboardModuleDetails[0].WallboardModuleKey;

        switch (this.wvf.Slides[this.wvf.CurrentSlide].TransitionID) {
            case 0: // None
            case 1: // Blinds
            case 2: // Checkerboard
            case 3: // Dissolve
                break;
            case 4: // Fade
                $(".wallboardViewSlide[mid=" + moduleKey + "]:first").fadeOut(1000);
                break;
            case 5: // Flip
                $(".wallboardViewSlide[mid=" + moduleKey + "]:first").css({ "-webkit-animation": "flip 1s", "animation": "flip 1s" });
                break;
            case 6: // Pin Hole
                $(".wallboardViewSlide[mid=" + moduleKey + "]:first").css({ "-webkit-animation": "pinhole 1s", "animation": "pinhole 1s" });
                break;
            case 7: // Shatter
                break;
            case 8: // Slide Bottom
                $(".wallboardViewSlide[mid=" + moduleKey + "]:first").css("top", "-100vh");
                break;
            case 9: // Slide Left
                $(".wallboardViewSlide[mid=" + moduleKey + "]:first").css("left", "100vw");
                break;
            case 10: // Slide Right
                $(".wallboardViewSlide[mid=" + moduleKey + "]:first").css("left", "-100vw");
                break;
            case 11: // Slide Top
                $(".wallboardViewSlide[mid=" + moduleKey + "]:first").css("top", "100vh");
                break;
            default:
                $(".wallboardViewSlide[mid=" + moduleKey + "]:first").css("left", "100vw");
                break;
        }
    }
}
